module.exports = __webpack_public_path__ + "afe7f470db913bc7fccdc62a9c9bc524.jpg";